import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
const actionPrefix = `${reduxKey}.MODULE`;
export const fetchModulesSuccess = createAction(`${reduxKey}.MODULES.FETCH.SUCCESS`, (payload)=>payload);
export const fetchModuleSuccess = createAction(`${actionPrefix}.FETCH.SUCCESS`, (payload)=>payload);
export const updateModule = createAction(`${actionPrefix}.UPDATE`, (payload)=>payload);
export const fetchModuleEndpoint = createAction(`${actionPrefix}.ENDPOINT.FETCH`, (payload)=>payload);
export const fetchModuleEndpointSuccess = createAction(`${actionPrefix}.ENDPOINT.FETCH.SUCCESS`, (payload)=>payload);
export const fetchModuleEndpointError = createAction(`${actionPrefix}.ENDPOINT.FETCH.ERROR`, (payload)=>payload);
export const fetchModuleEndpointPurgeData = createAction(`${actionPrefix}.ENDPOINT.PURGE_DATA`, (payload)=>payload);
export const purgeAllModules = createAction(`${actionPrefix}.PURGE.ALL`, ()=>({}));
